import { render, staticRenderFns } from "./CorruptionSection.vue?vue&type=template&id=ea7f2464&scoped=true&ref=adminUser&"
import script from "./CorruptionSection.vue?vue&type=script&lang=js&"
export * from "./CorruptionSection.vue?vue&type=script&lang=js&"
import style0 from "./CorruptionSection.vue?vue&type=style&index=0&id=ea7f2464&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea7f2464",
  null
  
)

export default component.exports